import React from 'react';

export const EmptyTable = ({ text = 'Kirjed puuduvad' }) => (
  <tr>
    <td colSpan={100}>
      <div className="no-content">
        <div>{text}</div>
      </div>
    </td>
  </tr>
);
